import React from 'react';
import { isGlazing36mm } from '../lib/vmkGlazing';

const publicUrl = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const wrap = (className, children) => (
  <svg
    className={className}
    width={86}
    height={86}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    {children}
  </svg>
);

export const VmkSpecProfileIllustration = () => (
  <img
    src={publicUrl('/images/vmk-specs/spec-profile.png')}
    alt=""
    className="vmk-specs-icon-image vmk-specs-icon-photo"
  />
);

export const VmkSpecGlassIllustration = ({ glazingTypeId = 'double' }) => {
  const isTriple = isGlazing36mm(glazingTypeId);
  const src = publicUrl(
    isTriple
      ? '/images/vmk-specs/spec-glass-triple.png'
      : '/images/vmk-specs/spec-glass-double.png'
  );

  return (
    <img
      src={src}
      alt=""
      className="vmk-specs-icon-image vmk-specs-icon-photo"
    />
  );
};

export const VmkSpecSecurityIllustration = () =>
  wrap(
    'vmk-specs-icon-image',
    <>
      <path
        d="M60 18 88 30v28c0 18-12 32-28 36-16-4-28-18-28-36V30l28-12z"
        stroke="#179f9f"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <rect x="48" y="52" width="24" height="20" rx="3" stroke="#179f9f" strokeWidth="2" />
      <path d="M52 52v-6a8 8 0 0 1 16 0v6" stroke="#179f9f" strokeWidth="2" strokeLinecap="round" />
      <circle cx="60" cy="62" r="2.5" fill="#179f9f" />
    </>
  );

export const VMK_SPEC_ILLUSTRATIONS = [
  VmkSpecProfileIllustration,
  VmkSpecSecurityIllustration,
];
